import { useCallback } from 'react';

export function useChangeCallback(
	onChange: (value: string) => void,
): (event: React.ChangeEvent<HTMLInputElement>) => void {
	return useCallback((event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value), [onChange]);
}
